export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5055.48f4ca11.jpg";